if (!customElements.get('quick-add-modal')) {
  customElements.define('quick-add-modal', class QuickAddModal extends ModalDialog {
    constructor() {
      super();
      this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
    }

    hide(preventFocus = false) {
      const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (cartNotification) cartNotification.setActiveElement(this.openedBy);
      this.modalContent.innerHTML = '';

      if (preventFocus) this.openedBy = null;
      super.hide();
    }

    show(opener) {
      opener.setAttribute('aria-disabled', true);
      opener.classList.add('loading');
      opener.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      fetch(opener.getAttribute('data-product-url'))
        .then((response) => response.text())
        .then((responseText) => {
          const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
          this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');
          this.preventDuplicatedIDs();
          this.removeDOMElements();
          this.setInnerHTML(this.modalContent, this.productElement.innerHTML);
          if (window.Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }

          if (window.ProductModel) window.ProductModel.loadShopifyXR();

          this.removeGalleryListSemantic();
          this.updateImageSizes();
          this.preventVariantURLSwitching();

           // Custom CW script execution starts here
            let element = this.modalContent.querySelector(".grid__item.product__media-wrapper media-gallery");
            let sizeelement = this.modalContent.querySelector("#cw-openModal");
            if(sizeelement){
              sizeelement.innerHTML = "Size Chart"
              const newDiv = document.createElement("div");
              newDiv.classList.add("cw-modal")
              newDiv.id = "cw-modal";
              newDiv.innerHTML = `
                  <div class="cw-modal-overlay"></div>
                    <div class="cw-modal-content">
                    <button class="cw-close-btn" id="cw-closeModal">
                      <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M1 1L11 11M11 1L0.999999 11" stroke="black" stroke-width="1.6122"/>
                      </svg>
                    </button>
                    <img src="//katamu.co/cdn/shop/files/size-chart.png?v=1732687039" alt="cw-size-chart-image"/>
                  </div>
              `;
             sizeelement.insertAdjacentElement('afterend', newDiv);
              const openModal = document.getElementById('cw-openModal');
              const quickAddContentInfo = openModal.closest('.quick-add-modal');
              const closeModal = document.getElementById('cw-closeModal');
              const modal = document.getElementById('cw-modal');
              const overlay = document.querySelector('.cw-modal-overlay');
              openModal.addEventListener('click', () => {
                modal.style.display = 'flex';
                quickAddContentInfo.classList.add('active-size-chart');
              });
              closeModal.addEventListener('click', () => {
                modal.style.display = 'none';
                quickAddContentInfo.classList.remove('active-size-chart');
              });
              overlay.addEventListener('click', () => {
                modal.style.display = 'none';
                quickAddContentInfo.classList.remove('active-size-chart');
              });
            }
            if (element) {
                element.style.display = "none";

              const htmlContent = `
                      <div class="cw-slider-wrapper" style="visibility: hidden; opacity: 0;">
                          <div class="cw-main-slider swiper">
                              <div class="swiper-wrapper"></div>
                              <div class="swiper-button-next"></div>
                              <div class="swiper-button-prev"></div>
                          </div>
                          <div class="cw-thumbnail-slider swiper">
                              <div class="swiper-wrapper"></div>
                          </div>
                      </div>
                      <div class="cw-popup">
                          <span class="cw-close-btn">
                              <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-close" fill="none" viewBox="0 0 18 17">
                                  <path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z" fill="currentColor"></path>
                              </svg>
                          </span>
                          <img src="" alt="Popup Image">
                      </div>
                  `;
                element.insertAdjacentHTML("afterend", htmlContent);

                const imageElements = this.modalContent.querySelectorAll(
                    "slider-component .product__media-list li.product__media-item .product-media-container .product__media > img"
                );
                let imageSources = Array.from(imageElements).map((elem) => elem.getAttribute("src"));

                const mainSliderWrapper = this.modalContent.querySelector(".cw-main-slider .swiper-wrapper");
                const thumbnailSliderWrapper = this.modalContent.querySelector(".cw-thumbnail-slider .swiper-wrapper");

                imageSources.forEach((src) => {
                    mainSliderWrapper.innerHTML += `
            <div class="swiper-slide">
                <img src="${src}" alt="Main Slider Image">
            </div>`;
                    thumbnailSliderWrapper.innerHTML += `
            <div class="swiper-slide">
                <img src="${src}" alt="Thumbnail Image">
            </div>`;
                });

                function initializeSliders() {
                    const thumbnailSwiper = new Swiper(".cw-thumbnail-slider", {
                        slidesPerView: 5,
                        spaceBetween: 8,
                        slideToClickedSlide: true,
                        watchSlidesProgress: true,
                    });

                    const mainSwiper = new Swiper(".cw-main-slider", {
                        slidesPerView: 1,
                        centeredSlides: false,
                        navigation: {
                            nextEl: ".swiper-button-next",
                            prevEl: ".swiper-button-prev",
                        },
                        thumbs: {
                            swiper: thumbnailSwiper,
                        },
                    });

                    const sliderWrapper = document.querySelector(".cw-slider-wrapper");
                    sliderWrapper.style.visibility = "visible";
                    sliderWrapper.style.opacity = "1";
                }

                function loadSwiperScript() {
                    const swiperScript = document.createElement("script");
                    swiperScript.src = "https://cdn.jsdelivr.net/npm/swiper/swiper-bundle.min.js";
                    document.head.appendChild(swiperScript);
                    swiperScript.onload = initializeSliders;
                }

                function loadSwiperCSS() {
                    const swiperCSS = document.createElement("link");
                    swiperCSS.rel = "stylesheet";
                    swiperCSS.href = "https://cdn.jsdelivr.net/npm/swiper/swiper-bundle.min.css";
                    document.head.appendChild(swiperCSS);
                    swiperCSS.onload = loadSwiperScript;
                }

                loadSwiperCSS();
                const popup = document.querySelector(".cw-popup");
                const quickAddpopup = popup.closest('.quick-add-modal');
                const popupImage = popup.querySelector("img");
                const closeButton = popup.querySelector(".cw-close-btn");
              
                document.querySelectorAll(".cw-main-slider img").forEach((img) => {
                  img.addEventListener("click", function () {
                    popupImage.src = this.src;
                    popup.style.display = "flex";
                   quickAddpopup.classList.add('active-main-popup');
                  });
                });
              
                closeButton.addEventListener("click", function () {
                  popup.style.display = "none";
                   quickAddpopup.classList.remove('active-main-popup');
                });
              
                popup.addEventListener("click", function (e) {
                  if (e.target === popup) {
                    popup.style.display = "none";
                   quickAddpopup.classList.remove('active-main-popup');
                  }
                });
            }
            // Custom CW script execution ends here
          
          super.show(opener);
          
        })
        .finally(() => {
          opener.removeAttribute('aria-disabled');
          opener.classList.remove('loading');
          opener.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    setInnerHTML(element, html) {
      element.innerHTML = html;

      // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
      element.querySelectorAll('script').forEach(oldScriptTag => {
        const newScriptTag = document.createElement('script');
        Array.from(oldScriptTag.attributes).forEach(attribute => {
          newScriptTag.setAttribute(attribute.name, attribute.value)
        });
        newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
        oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
      });
    }

    preventVariantURLSwitching() {
      const variantPicker = this.modalContent.querySelector('variant-radios,variant-selects');
      if (!variantPicker) return;

      variantPicker.setAttribute('data-update-url', 'false');
    }

    removeDOMElements() {
      const pickupAvailability = this.productElement.querySelector('pickup-availability');
      if (pickupAvailability) pickupAvailability.remove();

      const productModal = this.productElement.querySelector('product-modal');
      if (productModal) productModal.remove();

      const modalDialog = this.productElement.querySelectorAll('modal-dialog');
      if (modalDialog) modalDialog.forEach(modal => modal.remove());
    }

    preventDuplicatedIDs() {
      const sectionId = this.productElement.dataset.section;
      this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${ sectionId }`);
      this.productElement.querySelectorAll('variant-selects, variant-radios, product-info').forEach((element) => {
        element.dataset.originalSection = sectionId;
      });
    }

    removeGalleryListSemantic() {
      const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
      if (!galleryList) return;

      galleryList.setAttribute('role', 'presentation');
      galleryList.querySelectorAll('[id^="Slide-"]').forEach(li => li.setAttribute('role', 'presentation'));
    }

    updateImageSizes() {
      const product = this.modalContent.querySelector('.product');
      const desktopColumns = product.classList.contains('product--columns');
      if (!desktopColumns) return;

      const mediaImages = product.querySelectorAll('.product__media img');
      if (!mediaImages.length) return;

      let mediaImageSizes = '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';
      
      if (product.classList.contains('product--medium')) {
        mediaImageSizes = mediaImageSizes.replace('715px', '605px');
      } else if (product.classList.contains('product--small')) {
        mediaImageSizes = mediaImageSizes.replace('715px', '495px');
      }

      mediaImages.forEach(img => img.setAttribute('sizes', mediaImageSizes));
    }
  });
}
